import { useTranslation } from "react-i18next";
import { formatDateTime } from "@/lib/format";

import type { TicketMessage } from "@/lib/support";

const SYSTEM_KEY: Record<string, string> = {
  "status.changed": "support.thread.system.statusChanged",
  assigned: "support.thread.system.assigned",
  "sla.breached": "support.thread.system.slaBreached",
  "call.started": "support.thread.system.callStarted",
};

function SystemRow({ msg }: { msg: TicketMessage }) {
  const { t } = useTranslation();
  const event = String(msg.payload_jsonb?.event ?? "event");
  const label = SYSTEM_KEY[event] ? t(SYSTEM_KEY[event]) : event;
  return (
    <div className="my-2 text-center text-xs text-nb-text-2">
      — {label} · {formatDateTime(msg.created_at)} —
    </div>
  );
}

export function TicketThread({ messages }: { messages: TicketMessage[] }) {
  const { t } = useTranslation();
  return (
    <div className="space-y-3">
      {messages.map((m) => {
        if (m.kind === "system") return <SystemRow key={m.id} msg={m} />;
        const mine = !m.author_is_agent;
        return (
          <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
            <div
              className={
                "max-w-[80%] rounded-lg border px-3 py-2 " +
                (m.is_internal_note
                  ? "border-amber-500/40 bg-amber-500/10"
                  : mine
                    ? "border-cvp-accent/40 bg-cvp-accent/10"
                    : "border-nb-border bg-nb-surface")
              }
            >
              <div className="mb-0.5 text-xs text-nb-text-2">
                {m.author_display}
                {m.is_internal_note && ` · ${t("support.thread.internalNote")}`} ·{" "}
                {formatDateTime(m.created_at)}
              </div>
              <div className="whitespace-pre-wrap text-sm text-nb-text">{m.body}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
